<micro-select-combo #sel
              placeholder="Month"
              [mode]="mode"
              [(id)]="month"
              (idChange)="change($event)"
              [options]="options"
              [required]="required"
              [disabled]="disabled"
>
</micro-select-combo>
